import useSyllabus from './useSyllabus';
import useGoalInfo from '../useGoalInfo';

const useFullSyllabusInfo = (
  goalUID,
  fallbackData = {},
  isNewSyllabus,
  isRecordedGoal
) => {
  const { key: syllabusSWRKey } = useSyllabus(
    goalUID,
    isNewSyllabus,
    {},
    isRecordedGoal,
    {
      fallbackData: fallbackData.syllabusData
    }
  );

  const { key: goalInfoSWRKey } = useGoalInfo(goalUID, {
    fallbackData: fallbackData.goalData
  });

  return {
    keys: {
      syllabusSWRKey,
      goalInfoSWRKey
    }
  };
};

export default useFullSyllabusInfo;
